import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { Location } from '@angular/common';
import { InspectionModelService } from '../../services/index';
import { InspectionSection } from '../../models/index';
import { BaseModalPageComponent } from '../../../base-modal.component';

import * as _ from 'lodash';

@Component({
    templateUrl: './model-sections.component.html',
    standalone: false
})
export class ImportPointsModelSectionsPageComponent extends BaseModalPageComponent implements OnInit {
  model: any;
  inspectionId: string;
  sectionId: string;
  folderId: string;
  modelId: string;
  selectedSection: InspectionSection;
  errorMessage: string;
  navigationRoute: string;

  public loading: Boolean = true;

  constructor(
    public service: InspectionModelService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    location: Location,
    private cdRef: ChangeDetectorRef
  ) {
    super(location);
  }

  ngOnInit(): void {
    this.navigationRoute = this.router.url.includes('inspections') ? this.inspectionsRoute : this.templatesRoute;
    this.initRoute();
  }

  initRoute(): void {
    this.activatedRoute.params.subscribe((params: Params) => {
      const id = params['targetId'];
      if (id == null) this.router.navigate([this.navigationRoute]);

      this.inspectionId = id;

      const sectionId = params['sectionId'];
      if (sectionId == null) this.router.navigate([this.navigationRoute, this.inspectionId]);

      this.sectionId = sectionId;

      this.folderId = params['folderId'];

      const modelId = params['modelId'];
      if (modelId == null) this.router.navigate([this.navigationRoute, this.inspectionId]);

      this.modelId = modelId;

      this.initData();
    });
  }

  selectInspectionSection(section: any): void {
    this.resetSelectedSection();
    section.selected = !section.selected;
    this.selectedSection = section;
    this.cdRef.detectChanges();
  }

  openSection(): void {
    if (this.folderId) {
      this.router.navigate([
        this.navigationRoute,
        this.inspectionId,
        'sections',
        this.sectionId,
        'folders',
        this.folderId,
        'addpoint',
        this.modelId,
        this.selectedSection.id
      ]);
    } else {
      this.router.navigate([
        this.navigationRoute,
        this.inspectionId,
        'sections',
        this.sectionId,
        'addpoint',
        this.modelId,
        this.selectedSection.id
      ]);
    }

    this.resetSelectedSection();
  }

  cancel() {
    this.resetSelectedSection();
    this.goToBack();
  }

  initData(): void {
    this.service.getModel(this.modelId).subscribe((model) => {
      this.model = model;
      this.loading = false;
    });
  }

  resetSelectedSection() {
    this.model.sections.forEach((s) => (s.selected = false));
  }
}
